import * as React from 'react';

const RefreshStockButton = (props) => {
    return (
        <>
            {props?.fetchInventoryFromServer ? <a onClick={() => {
                props.fetchInventoryFromServer();
            }} style={{
                cursor: 'pointer'
            }} id="listing" className="refresh-link">
                <i className="fa fa-refresh mx-2 grey-refresh" />
                <i className="thin text-none font-11">Refresh Stock</i>
            </a> :
                <a style={{ cursor: 'auto' }} className="refresh-link">
                    <i className="fa fa-refresh mx-2 grey-refresh" />
                    <i className="thin text-none font-11">Refresh Stock</i>
                </a>
            }

        </>
    );
};

export default RefreshStockButton;